module.exports = __webpack_public_path__ + "static/media/notification.0de5486f.png";